module.exports = __webpack_public_path__ + "static/media/sgs_kr.e0c60b67.e0c60b67.jpg";